export default "__VITE_ASSET__ZS$pqH2I__"